import { v3 } from '@adobe/edex/frontend/api/v3';
import { isEmpty } from 'lodash-es';

const getCourseBaseURL = `api/v1/courses`;
const updateCourseBaseURL = `api/v1/course`;
const getLiveCourseBaseURL = `api/v1/live-course-mapping`;

function changeBadgeKeyTocredlyBadges(result) {
  result.data['credlyBadges'] = result.data.badges;
  delete result.data.badges;
  return result;
}

export async function fetchCourse(id) {
  const result = await v3.get(`${getCourseBaseURL}/${id}`);
  return changeBadgeKeyTocredlyBadges(result);
}

export async function updateCourse(id, params) {
  if (!isEmpty(params)) {
    const result = await v3.patch(`${updateCourseBaseURL}/${id}`, params);
    return changeBadgeKeyTocredlyBadges(result);
  }
}

export async function fetchLiveCourseFromDraftCourseID(id) {
  const result = await v3.get(`${getLiveCourseBaseURL}?nonLiveCourseID=${id}`);
  return changeBadgeKeyTocredlyBadges(result);
}
